import React from 'react';
import { FormattedDate } from 'react-intl';
import { styled } from '@linaria/react';
import { Text } from '@vio/atlas/Text';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
const DatesWrapper = /*#__PURE__*/styled('div')({
  name: "DatesWrapper",
  class: "d15efquo",
  propsAsIs: false
});
type SelectedDatesLabelProps = {
  checkIn?: string | null;
  checkOut?: string | null;
  dateRange?: string | null;
  isCompact?: boolean;
};
const getCombinedDateRange = (dateValue: string, dateRange: string | null, isCompact: boolean) => {
  return <>
      <Text variant="titleS" tag="span">
        {isCompact ? <FormattedDate value={dateStringToMiddayDate(dateValue)} day="2-digit" month="short" /> : <FormattedDate value={dateStringToMiddayDate(dateValue)} day="2-digit" month="short" weekday="short" />}
      </Text>{' '}
      {dateRange && <Text variant="titleS" tag="span">
          ± {dateRange}
        </Text>}
    </>;
};
export const SelectedDatesLabel = ({
  checkIn,
  checkOut,
  dateRange = null,
  isCompact = false
}: SelectedDatesLabelProps) => {
  return <DatesWrapper>
      {checkIn ? getCombinedDateRange(checkIn, dateRange, isCompact) : <Text variant="titleS" tag="span" colorPath="content.neutral.c400">
          <FormattedMessageWrapper id="checkIn" defaultMessage="Check-in" />
        </Text>}
      <Text variant="titleS" tag="span">
        {' - '}
      </Text>
      {checkOut ? getCombinedDateRange(checkOut, dateRange, isCompact) : <Text variant="titleS" tag="span" colorPath="content.neutral.c400">
          <FormattedMessageWrapper id="checkOut" defaultMessage="Check-out" />
        </Text>}
    </DatesWrapper>;
};

require("./SelectedDatesLabel.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SelectedDatesLabel.tsx");